<mat-stepper [disableRipple]="true" [selectedIndex]="selectors.currentCreateAccountStep | select" labelPosition="bottom"
             class="px-stepper-locked lg:mx-10">
  <mat-step label="Create Account" [completed]="selectors.isComplete('enterEmail') | select" [editable]="false">
    <px-registration-email-form/>
  </mat-step>
  <mat-step label="Verify Email" [completed]="selectors.isComplete('verifyEmail') | select" [editable]="false">
    @if (selectors.verificationExpired | select) {
      <px-registration-verify-email-expired/>
    } @else {
      <px-registration-verify-email-form/>
    }
  </mat-step>
  <mat-step label="Details" [completed]="selectors.isComplete('enterDetails') | select" [editable]="false">
    <px-registration-details-form/>
  </mat-step>
  <mat-step label="Notifications" [completed]="selectors.isComplete('setNotifications') | select" [editable]="false">
    <px-registration-notifications-form [email]="selectors.email | select:''"/>
  </mat-step>
  <mat-step label="Create Password" [completed]="selectors.isComplete('createPassword') | select" [editable]="false">
    <px-registration-create-password-form [pickupBranchId]="selectors.branchId | select:0"/>
  </mat-step>
  <mat-step label="Complete">
    <px-registration-complete/>
  </mat-step>
</mat-stepper>
